'use client';

import { Suspense } from 'react';
import { ProfileView } from '@/components/ProfileView';
import { PageSkeleton } from '@/components/PageSkeleton';
import { AppHeaderConfig } from '@/contexts/AppHeaderContext';
import { useChatPage } from '@/hooks/useChatPage';

export default function ProfilePage() {
  useChatPage('profile');

  return (
    <>
      <AppHeaderConfig hidePeriodPicker />
      <Suspense fallback={<PageSkeleton />}>
        <ProfileView />
      </Suspense>
    </>
  );
}
